import React, { Component } from 'react';
import {
  BG,
  Container,
  Player,
  CurrentAlbum,
  Controls,
  Play,
} from './music.css';
import axios from 'axios';
import Config from '../../../site-config';
import Spotify from '../../../static/spotify.svg';
import Apple from '../../../static/apple.svg';
import GooglePlay from '../../../static/google-play.svg';
import Amazon from '../../../static/amazon.svg';
import PlayOverlay from '../../../static/playoverlay.svg';
import StopOverlay from '../../../static/stopoverlay.svg';

class Music extends Component {
  constructor() {
    super();

    this.controls = React.createRef();

    this.state = {
      sidebarClosed: true,
      isPlaying: false,
      albumIndex: 0,
      albums: [],
      activeEmbed: '',
      hasLoaded: false,
    };
  }

  componentDidMount() {
    this.getData();
  }

  togglePlayer = code => {
    this.setState(state => {
      return {
        sidebarClosed: !state.sidebarClosed,
        isPlaying: !state.isPlaying,
        activeEmbed: code,
      };
    });
  };

  changeAlbum = id => {
    const { albums } = this.state;

    const newAlbum = albums.find(album => album.id === id);
    const otherAlbums = albums.filter(album => album.id !== id);

    this.setState({
      albums: [newAlbum, ...otherAlbums],
    });
  };

  iframe = code => {
    return {
      __html: code,
    };
  };

  handleControlClick = e => {
    const { isPlaying } = this.state;
    if (isPlaying && this.controls.current.contains(e.target)) {
      this.setState({
        sidebarClosed: true,
        isPlaying: false,
      });
    }
  };

  getData = async () => {
    const albums = await axios.get(
      `https://cdn.contentful.com/spaces/${
        Config.contentFul.spaceId
      }/environments/master/entries/?access_token=${
        Config.contentFul.access_token
      }&content_type=musicList`
    );

    const orderedIds = albums.data.items[0].fields.albums.map(
      entry => entry.sys.id
    );

    const cleanAlbums = orderedIds.map((ID, index) => {
      const m = albums.data.includes.Entry.find(vid => vid.sys.id === ID);
      const img = albums.data.includes.Asset.find(
        image => image.sys.id === m.fields.albumCover.sys.id
      );

      return {
        id: index,
        title: m.fields.title,
        cover: img.fields.file.url,
        spotify_embed: m.fields.spotifyEmbedCode,
        apple_embed: m.fields.appleEmbedCode,
        amazon: m.fields.amazonUrl,
        google_play: m.fields.googlePlayUrl,
      };
    });

    this.setState({
      albums: cleanAlbums,
      hasLoaded: true,
    });
  };

  render() {
    const {
      hasLoaded,
      sidebarClosed,
      isPlaying,
      albums,
      activeEmbed,
    } = this.state;

    if (!hasLoaded) return null;

    return (
      <Container open={sidebarClosed} name="music" id="listenSec">
        <Player>
          {isPlaying && (
            <div dangerouslySetInnerHTML={this.iframe(activeEmbed)} />
          )}
        </Player>

        <BG ref={this.controls} onClick={this.handleControlClick}>
          <CurrentAlbum
            onClick={() => this.togglePlayer(albums[0].spotify_embed)}
          >
            <div style={{ position: 'relative' }}>
              <Play
                src={isPlaying ? StopOverlay : PlayOverlay}
                alt="Play"
                isPlaying={isPlaying}
              />
              <img alt={albums[0].title} src={albums[0].cover} />
            </div>
            {/* {isPlaying && <div>Now Playing</div>} */}

            <div className="title">{albums[0].title}</div>
          </CurrentAlbum>

          <Controls>
            <div className="leftControls">
              <div className="status">{isPlaying ? 'Playing' : 'Listen'}</div>
              <div className="services">
                <button
                  onClick={() => this.togglePlayer(albums[0].spotify_embed)}
                >
                  <img src={Spotify} alt="spotify" />
                </button>
                <button
                  onClick={() => this.togglePlayer(albums[0].apple_embed)}
                >
                  <img src={Apple} alt="spotify" />
                </button>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href={albums[0].amazon}
                  style={{ position: 'relative', top: '3px' }}
                >
                  <img src={Amazon} alt="amazon" />
                </a>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href={albums[0].google_play}
                  style={{ position: 'relative', top: '1px' }}
                >
                  <img src={GooglePlay} alt="google play" />
                </a>
              </div>
            </div>

            <div className="rightControls">
              <button onClick={() => this.changeAlbum(albums[1].id)}>
                <div style={{ position: 'relative' }}>
                  <Play src={PlayOverlay} alt="Play" isPlaying={isPlaying} />
                  <img alt={albums[1].title} src={albums[1].cover} />
                </div>
              </button>

              <button onClick={() => this.changeAlbum(albums[2].id)}>
                <div style={{ position: 'relative' }}>
                  <Play src={PlayOverlay} alt="Play" isPlaying={isPlaying} />
                  <img alt={albums[2].title} src={albums[2].cover} />
                </div>
              </button>
            </div>
          </Controls>
        </BG>
      </Container>
    );
  }
}

export default Music;
